import { use } from "react";
import { WebviewContext } from ".";
import type { Nullable } from "../../@types/generic";
import {
    type InitialConfig,
    type UserLocation,
    Webview,
} from "../../bridge/types";

export const useIsWebview = (): Nullable<boolean> => {
    return use(WebviewContext)?.webview === Webview.app;
};

export const useInitialConfig = (): Nullable<InitialConfig> => {
    return use(WebviewContext)?.initialConfig ?? null;
};

export const useUserLocation = (): UserLocation | undefined => {
    return use(WebviewContext)?.userLocation;
};
